//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets data.
 * @param incomingNumber (optional) 
 * @param article (optional) 
 * @param serialNumber (optional) 
 * @param selectedStatuses (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 * @param language (optional) 
 */
export function get(incomingNumber?: string | undefined, article?: string | undefined, serialNumber?: string | undefined, selectedStatuses?: string[] | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, language?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RepairsResponseDto> {
    let url_ = getBaseUrl() + "/api/repairs?";
    if (incomingNumber === null)
        throw new Error("The parameter 'incomingNumber' cannot be null.");
    else if (incomingNumber !== undefined)
        url_ += "IncomingNumber=" + encodeURIComponent("" + incomingNumber) + "&";
    if (article === null)
        throw new Error("The parameter 'article' cannot be null.");
    else if (article !== undefined)
        url_ += "Article=" + encodeURIComponent("" + article) + "&";
    if (serialNumber === null)
        throw new Error("The parameter 'serialNumber' cannot be null.");
    else if (serialNumber !== undefined)
        url_ += "SerialNumber=" + encodeURIComponent("" + serialNumber) + "&";
    if (selectedStatuses === null)
        throw new Error("The parameter 'selectedStatuses' cannot be null.");
    else if (selectedStatuses !== undefined)
        selectedStatuses && selectedStatuses.forEach(item => { url_ += "SelectedStatuses=" + encodeURIComponent("" + item) + "&"; });
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
    if (language === null)
        throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGet?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGet(_response);
    });
}

function processGet(response: AxiosResponse): Promise<Types.RepairsResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRepairsResponseDto(resultData200);
        return Promise.resolve<Types.RepairsResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RepairsResponseDto>(null as any);
}

/**
 * Searches repair orders that have been created or entered.
 * @param search (optional) 
 */
export function getRepairOrdersForPdfGeneration(search?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RepairsResponseDto> {
    let url_ = getBaseUrl() + "/api/repairs/pdf-generation-list?";
    if (search === null)
        throw new Error("The parameter 'search' cannot be null.");
    else if (search !== undefined)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetRepairOrdersForPdfGeneration,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetRepairOrdersForPdfGeneration?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetRepairOrdersForPdfGeneration(_response);
    });
}

function processGetRepairOrdersForPdfGeneration(response: AxiosResponse): Promise<Types.RepairsResponseDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRepairsResponseDto(resultData200);
        return Promise.resolve<Types.RepairsResponseDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RepairsResponseDto>(null as any);
}

/**
 * Get Details By Incoming Number.
 * @param language (optional) 
 */
export function getDetailsByIncomingNumber(incomingNumber: string, language?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.RepairsDetailsDto> {
    let url_ = getBaseUrl() + "/api/repairs/details/{incomingNumber}?";
    if (incomingNumber === undefined || incomingNumber === null)
      throw new Error("The parameter 'incomingNumber' must be defined.");
    url_ = url_.replace("{incomingNumber}", encodeURIComponent("" + incomingNumber));
    if (language === null)
        throw new Error("The parameter 'language' cannot be null.");
    else if (language !== undefined)
        url_ += "language=" + encodeURIComponent("" + language) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDetailsByIncomingNumber,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDetailsByIncomingNumber?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDetailsByIncomingNumber(_response);
    });
}

function processGetDetailsByIncomingNumber(response: AxiosResponse): Promise<Types.RepairsDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initRepairsDetailsDto(resultData200);
        return Promise.resolve<Types.RepairsDetailsDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.RepairsDetailsDto>(null as any);
}
let _requestConfigGet: Partial<AxiosRequestConfig> | null;
export function getGetRequestConfig() {
  return _requestConfigGet;
}
export function setGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGet = value;
}
export function patchGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGet = patch(_requestConfigGet ?? {});
}

let _requestConfigGetRepairOrdersForPdfGeneration: Partial<AxiosRequestConfig> | null;
export function getGetRepairOrdersForPdfGenerationRequestConfig() {
  return _requestConfigGetRepairOrdersForPdfGeneration;
}
export function setGetRepairOrdersForPdfGenerationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetRepairOrdersForPdfGeneration = value;
}
export function patchGetRepairOrdersForPdfGenerationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetRepairOrdersForPdfGeneration = patch(_requestConfigGetRepairOrdersForPdfGeneration ?? {});
}

let _requestConfigGetDetailsByIncomingNumber: Partial<AxiosRequestConfig> | null;
export function getGetDetailsByIncomingNumberRequestConfig() {
  return _requestConfigGetDetailsByIncomingNumber;
}
export function setGetDetailsByIncomingNumberRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDetailsByIncomingNumber = value;
}
export function patchGetDetailsByIncomingNumberRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDetailsByIncomingNumber = patch(_requestConfigGetDetailsByIncomingNumber ?? {});
}